import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-cascade",
  "use": "icon-cascade-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-cascade\"><defs><style type=\"text/css\"></style></defs><path d=\"M204.8 512V281.6c0-12.8 10.24-25.6 25.6-25.6h307.2c15.36 0 25.6 10.24 25.6 25.6V512c0 12.8-10.24 25.6-25.6 25.6H512v51.2h51.2c28.16 0 51.2-23.04 51.2-51.2V256c0-28.16-23.04-51.2-51.2-51.2H204.8c-28.16 0-51.2 23.04-51.2 51.2v281.6c0 28.16 23.04 51.2 51.2 51.2h153.6v-51.2h-128c-12.8 0-25.6-10.24-25.6-25.6z m0 0\" p-id=\"1752\" /><path d=\"M819.2 435.2H665.6v51.2h128c15.36 0 25.6 10.24 25.6 25.6v230.4c0 12.8-10.24 25.6-25.6 25.6H486.4c-15.36 0-25.6-10.24-25.6-25.6V512c0-12.8 10.24-25.6 25.6-25.6H512v-51.2h-51.2c-28.16 0-51.2 23.04-51.2 51.2V768c0 28.16 23.04 51.2 51.2 51.2h358.4c28.16 0 51.2-23.04 51.2-51.2V486.4c0-28.16-23.04-51.2-51.2-51.2z m0 0\" p-id=\"1753\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/cascade.svg
// module id = /pBg
// module chunks = 54